"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XTransferTarget = /** @class */ (function () {
    function XTransferTarget(accountId) {
        this.accountId = accountId;
    }
    return XTransferTarget;
}());
exports.default = XTransferTarget;
//# sourceMappingURL=xtransfer-target.js.map